import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { ROUTE_IDS, StepDefinition } from '@lx/quote-tool/shared/types';
import { EnrolmentPaymentComponent } from './enrolment-payment.component';

@Injectable({
  providedIn: 'root',
})
export class EnrolmentPaymentResolver {
  private stepDefinition: StepDefinition = {
    stepId: ROUTE_IDS.ENROLMENT_PAYMENT,
    displayQuote: true,
    nextStep: () => ROUTE_IDS.FLYWIRE_PAYMENT,
    previousStep: () => ROUTE_IDS.BOOKING_FORM,
  };

  resolve(): StepDefinition {
    return this.stepDefinition;
  }
}

export const stepRoute: Route = {
  path: ROUTE_IDS.BOOKING_ENROLMENT_PAYMENT,
  resolve: {
    stepDefinition: EnrolmentPaymentResolver,
  },
  component: EnrolmentPaymentComponent,
};
